export default {
    YES: {
        text: 'Ja',
        value: true
    },
    NO: {
        text: 'Nein',
        value: false
    }
};